import React, {Component} from 'react';

import './styles.scss';
import {getRapidNaming} from '../../constants/tests.js';
import {normingGrade567YouthAdultImages} from './assets';
import {TYPES} from '../../constants/index';

class Test extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStep: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {}


	startNewTask = (taskNumber) => {
		this.setState({
			currentStep: taskNumber,
		});
	};

	getImage = (color, item) => {
		console.log('This is the color ', color);
				console.log('This is the item ', item);
				console.log('This is props.testKeyType ', this.props.testKeyType);
				console.log(' TYPES ',TYPES);
		if (
			this.props.testKeyType === TYPES.ADULT_FOLLOWUP ||
			this.props.testKeyType === TYPES.YOUTH_FOLLOWUP
		) {
			if (normingGrade567YouthAdultImages[color + item])
				return normingGrade567YouthAdultImages[color + item];
		} 
		console.error('Item ' + color + item + ' not found');
		return null;
	};

	render() {
		const {currentStep} = this.state;
		const steps = getRapidNaming(this.props.ageGroup).getAnswers();
		const itemsPerRow = steps[0].length;
		const currentRow = Math.min(
			Math.floor(currentStep / itemsPerRow),
			steps.length - 1
		);
		const currentItem = Math.floor(currentStep % itemsPerRow);

		const row = steps[currentRow] || null;
		const previousRow = steps[currentRow - 1] || null;
		const nextRow = steps[currentRow + 1] || null;

		return (
			<div className="ScrollingTest">
				<div className="row previous">
					{previousRow &&
						previousRow.map((item, index) => (
							<p key={index} className={`item`}>
								<img
									src={this.getImage(item.color, item.item)}
									alt={`A ${item.color} ${item.item}`}
								/>
								{(currentRow - 1) * itemsPerRow + index + 1}
							</p>
						))}
				</div>
				<div className="row">
					{row &&
						row.map((item, index) => (
							<p
								key={index}
								className={`item${
									currentItem === index ? ' active' : ''
								}`}
							>
								<img
									src={this.getImage(item.color, item.item)}
									alt={`A ${item.color} ${item.item}`}
								/>
								{currentRow * itemsPerRow + index + 1}
							</p>
						))}
				</div>
				<div className="row next">
					{nextRow &&
						nextRow.map((item, index) => (
							<p key={index} className={`item`}>
								<img
									src={this.getImage(item.color, item.item)}
									alt={`A ${item.color} ${item.item}`}
								/>
								{(currentRow + 1) * itemsPerRow + index + 1}
							</p>
						))}
				</div>
			</div>
		);
	}
}

export default Test;
